import React from "react";
import { Helmet } from "react-helmet-async";

const TodoPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Todo App</title>
        <meta name="description" content="Manage your todos" />
      </Helmet>
      <h1>Todo</h1>
    </>
  );
};

export default TodoPage;

